import { createAction, createReducer } from '@reduxjs/toolkit';
export const initialState = {
    dealerCode: '',
    dealerName: '',
};
export const setDealerData = createAction('dealer/setDealerData');
export const resetDealerData = createAction('dealer/resetDealerData');
const dealer = createReducer(initialState, builder => {
    builder
        .addCase(setDealerData, (state, action) => {
        var _a, _b, _c;
        const newDealer = action.payload;
        return (newDealer === null || newDealer === void 0 ? void 0 : newDealer.dealerCode) && (newDealer === null || newDealer === void 0 ? void 0 : newDealer.dealerName)
            ? {
                ...newDealer,
                provinceCode: (_a = newDealer === null || newDealer === void 0 ? void 0 : newDealer.provinceCode) !== null && _a !== void 0 ? _a : (_c = (_b = newDealer === null || newDealer === void 0 ? void 0 : newDealer.location) === null || _b === void 0 ? void 0 : _b.province) === null || _c === void 0 ? void 0 : _c.abbreviation,
            }
            : state;
    })
        .addCase(resetDealerData, () => initialState);
});
export const selectDealer = (state) => state.dealer;
export const selectDealerProvinceCode = (state) => { var _a; return (_a = state.dealer) === null || _a === void 0 ? void 0 : _a.provinceCode; };
export default dealer;
